import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';

import {AuthService} from '../../auth/auth.service';
import * as fromApp from '../../store/app.reducers';
import * as AuthActions from '../../auth/store/auth.actions';
import * as fromUser from '../../user/store/user.reducers';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  public mobileMenu = false;
  routerSubscription: Subscription;
  hideTopBar = false;
  userState: Observable<fromUser.State>;

  constructor(
    private store: Store<fromApp.AppState>,
    private authService: AuthService,
    private router: ActivatedRoute
  ) {}

  ngOnInit() {
    this.routerSubscription = this.router.url.subscribe(
      (data) => {
        this.hideTopBar = window.location.pathname.indexOf('signin') >= 0;
      }
    );
    this.userState = this.store.select('user');
  }

  logout() {
    this.store.dispatch(
      new AuthActions.Logout()
    );
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  toggleMenu($event) {
    this.mobileMenu = !this.mobileMenu;
    $event.stopPropagation();
  }

  closeMenuWhenOpen() {
    if (this.mobileMenu === true) {
      this.mobileMenu = false;
    }
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }
}
